import BOPContactDetailsView from 'text!../views/bop-contact-details.html';
import BOPPreQualQuestionsView from 'text!edge/quoteandbind/common/views/prequal-questions.html';
import BOPGeneralCoveragesView from 'text!../views/bop-general-coverages.html';
import BOPAdditionalCoveragesView from 'text!../views/bop-additional-coverages.html';
import BOPLocationsAndBuildingsView from 'text!../views/bop-locations-and-buildings.html';
import BOPPolicyInfoView from 'text!../views/bop-policy-info.html';

import BOPContactDetailsCtrl from '../controllers/BOPContactDetailsCtrl';
import BOPPreQualQuestionsCtrl from '../controllers/BOPPrequalQuestionsCtrl';
import BOPGeneralCoveragesCtrl from '../controllers/BOPGeneralCoveragesCtrl';
import BOPAdditionalCoveragesCtrl from '../controllers/BOPAdditionalCoveragesCtrl';
import BOPPolicyInfoCtrl from '../controllers/BOPPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        bopContactDetails: {
            parent: wizardParentState,
            template: BOPContactDetailsView,
            controller: BOPContactDetailsCtrl
        },
        bopPrequalQuestions: {
            parent: wizardParentState,
            template: BOPPreQualQuestionsView,
            controller: BOPPreQualQuestionsCtrl
        },
        bopGeneralCoverages: {
            parent: wizardParentState,
            template: BOPGeneralCoveragesView,
            controller: BOPGeneralCoveragesCtrl
        },
        bopAdditionalCoverages: {
            parent: wizardParentState,
            template: BOPAdditionalCoveragesView,
            controller: BOPAdditionalCoveragesCtrl
        },
        bopLocationsAndBuildings: {
            parent: wizardParentState,
            template: BOPLocationsAndBuildingsView,
            params: {
                // Building and location ids are passed to focus the location/building that was just edited
                buildingId: null,
                locationId: null
            }
        },
        bopPolicyInfo: {
            parent: wizardParentState,
            controller: BOPPolicyInfoCtrl,
            template: BOPPolicyInfoView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/bop/config/RouteConfig.js
// module id = 2103
// module chunks = 0